import CreateRubricDefault from './createRubricDefault';
import EditRubricDefault from './editRubricDefault';

export function createRubricDefault(parentProps){
  return CreateRubricDefault(parentProps);
}

export function editRubricDefault(parentProps){
  return EditRubricDefault(parentProps);
}